import { BreadCrumbSign } from "../../components/generic/breadcrumbSign.component";
import { EditUsers } from "../../components/users/EditUsers.component";
export const UsersEditPage = () => {
  return (
    <div className="row gx-0">
      <div className="col-12 m-2">
        <div className="d-flex flex-column px-1 me-3">
          <p className="content-header ms-1">
            Users <BreadCrumbSign /> Update
          </p>
          <EditUsers />
        </div>
      </div>
    </div>
  );
};
